import { PARAGRAPH_ATTRS } from '@root/helpers/editor';
import ParagraphExtension from '@tiptap/extension-paragraph';

import { lineSlot } from './line-slot';

export const Paragraph = ParagraphExtension.extend({
  addAttributes() {
    return {
      parentId: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-parentid'),
        renderHTML: (attributes: Record<string, any>) => {
          return {
            'data-parentid': attributes.parentId,
          };
        },
      },
      lineSlot,
      dataType: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute('data-type'),
        renderHTML: (attributes: Record<string, any>) => {
          return {
            'data-type': attributes.dataType,
          };
        },
      },
      fontSize: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute(PARAGRAPH_ATTRS.fontSize),
        renderHTML: ({ fontSize }: { fontSize: string | null }) => {
          if (!fontSize) {
            return {};
          }
          return { [PARAGRAPH_ATTRS.fontSize]: fontSize, style: `font-size: ${fontSize}` };
        },
      },
    };
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => {
        const { editor } = this;
        const { state } = editor;
        const { $from } = state.selection;

        if ($from.node().attrs.dataType === 'content-repeater-group-child') {
          editor.commands.first(({ commands }) => [
            () => commands.newlineInCode(),
            () => commands.createParagraphNear(),
            () => commands.liftEmptyBlock(),
            () => commands.splitBlock(),
          ]);
          // Remove repeater-related attributes from the new paragraph
          this.editor.commands.setNode('paragraph', {});
          return true;
        }

        return false;
      },
    };
  },
});
